import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'
import {
  callDataSelector,
  cameraAccessAllowedForVideoCallIdSelector,
  useStore,
} from '@liveHelper/models/store'

/**
 * @returns Whether the visitor is allowed to use camera.
 */
export const useVisitorCanUseCamera = (): boolean => {
  const chatChannelConfig = useChatChannelConfig()
  const cameraAccessAllowedForVideoCallId = useStore(
    cameraAccessAllowedForVideoCallIdSelector,
  )
  const callData = useStore(callDataSelector)

  return (
    !chatChannelConfig?.config?.camera_permission ||
    chatChannelConfig?.config.camera_permission ===
      'CAMERA_PERMISSION_ALWAYS_ALLOW' ||
    (chatChannelConfig?.config.camera_permission ===
      'CAMERA_PERMISSION_INVITE_ONLY' &&
      Boolean(cameraAccessAllowedForVideoCallId) &&
      Boolean(callData?.id) &&
      cameraAccessAllowedForVideoCallId === callData?.id)
  )
}
